import { useT } from '../i18n';
import { useGame } from '../store/game';
import { useNow } from '../lib/hooks';
import { PlayingCard } from '../cards/PlayingCard';

export function MatchmakingOverlay() {
  const mm = useGame((s) => s.mm);
  const cancel = useGame((s) => s.cancelMatchmaking);
  const t = useT();
  const now = useNow(500);
  if (!mm || (mm.state !== 'SEARCHING' && mm.state !== 'MATCHED')) return null;
  const startedAt = (mm as typeof mm & { _start?: number })._start ?? now - mm.elapsedMs;
  const elapsed = Math.max(mm.elapsedMs, now - startedAt);
  const progress = Math.min(1, elapsed / Math.max(1, mm.timeoutMs));
  return (
    <div className="overlay" role="dialog" aria-modal="true" aria-label={t('mm.searching')}>
      <div className="modal" style={{ textAlign: 'center' }}>
        <div className="row" style={{ justifyContent: 'center', marginBottom: 16, height: 110 }} aria-hidden>
          {['AS', 'KH', 'QD', 'JC'].map((c, i) => (
            <span key={c} style={{ animation: `pulse-text 1.2s ${i * 0.15}s infinite`, marginLeft: i ? -20 : 0, transform: `rotate(${(i - 1.5) * 10}deg)` }}>
              <PlayingCard id={c} size="lg" />
            </span>
          ))}
        </div>
        <h2>{mm.state === 'MATCHED' ? t('mm.matched') : t('mm.searching')}</h2>
        {mm.state === 'SEARCHING' && (
          <>
            <p className="dim" style={{ margin: '4px 0 14px' }}>{t('mm.waited', { s: Math.floor(elapsed / 1000) })}</p>
            <div className="progress" style={{ marginBottom: 12 }} aria-hidden>
              <span style={{ width: `${progress * 100}%` }} />
            </div>
            <button className="btn ghost block" onClick={() => void cancel()} style={{ marginTop: 12 }}>
              {t('mm.cancel')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
